var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetUnitSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.104,
    height: 17.903,
    viewBox: "0 0 20.104 17.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187434",
    "data-name": "Group 187434",
    transform: "translate(6925.001 3346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78715",
    "data-name": "Path 78715",
    d: "M20.1,30.893l-3.8-1.4V25.364l-1.872-.737V22.551l-4.374-1.618-4.375,1.6v2.094l-1.872.737v4.125L0,30.878v5.67l4.375,1.678,2.495-.957,3.183,1.567,3.182-1.567,2.494.957L20.1,36.548Zm-10.051-9.1,3.1,1.133-3.1,1.189-3.1-1.19Zm-8.78,9.481,3.1-1.133,3.1,1.133-3.1,1.19Zm8.78,6.334L8.275,36.73l.475-.182V30.88l-3.839-1.4V26.116l.768-.3V28.2l4.375,1.678L14.428,28.2V25.814l.768.3v3.361l-3.84,1.4v5.667l.475.182Zm2.575-6.334,3.1-1.133,3.1,1.133-3.1,1.19Z",
    transform: "translate(-6925.001 -3366.933)",
    fill: "#7D96FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetUnitSold);
export default __webpack_public_path__ + "static/media/net-unit-sold.fa90a2a05d1cebc274779e0018327ab5.svg";
export { ForwardRef as ReactComponent };